import moment from 'moment';
import React, { useEffect, useState } from 'react';
import Axiosfetch from '../Common/Axiosfetch';
import baseURL from '../Common/Config';
import FailureAlert from '../Common/Failure';
import { CallBackAlert } from '../Common/Validations/validation';

const ShowEventRegisterList = ({ EventDetails, hideeventresgisterMenu }) => {
    const [EventRegister, setEventRegister] = useState([]);

    useEffect(() => {
        FetchEventRecords();
    }, [])

    const FetchEventRecords = () => {
        Axiosfetch(baseURL + "GetActiveEventRegistrationsByEventID", "POST", {
            EventID: EventDetails._id
        }, EventRegisterSuccess, Failure);
    };

    const EventRegisterSuccess = (data) => {
        if (data && data.length > 0) {
            setEventRegister(data);
        }
        else {
            setEventRegister([]);
        }
    };

    const onApproveRegistration = (RegisterID, status) => {
        Axiosfetch(baseURL + "UpdateEventRegistrationApproval", "POST", {
            _id: RegisterID,
            Approved: status
        }, EventApproveSuccess, Failure);
    }

    const EventApproveSuccess = (data) => {
        if (data.success) {
            FetchEventRecords();
        }
        else {
            CallBackAlert(data);
        }
    }

    const OnRegisterPresent = (RegisterID, status) => {
        Axiosfetch(baseURL + "UpdateEventRegistrationPresent", "POST", {
            _id: RegisterID,
            Present: status
        }, EventApproveSuccess, Failure);
    }

    const Failure = (err) => {
        FailureAlert(err);
    };

    return (
        <div id="addProduct" className="modal" style={{ display: "block", paddingTop: "1%" }}>
            <div className="modal-content" style={{ width: "85%" }}>
                <div className={`modal-header header-style align-center`}>
                    <h6 className='pt-1' style={{ marginLeft: "5px" }}>Registered Members</h6>
                    <span className="close" onClick={hideeventresgisterMenu}>&times;</span>
                </div>
                {EventRegister && EventRegister.length > 0 && EventRegister.map(register => (
                    <div style={{ height: "75vh", overflow: "auto" }}>
                        <table className='table table-striped'>
                            <thead>
                                <tr>
                                    <th style={{ width: "150px" }}>Member</th>
                                    <th>Registeration ID</th>
                                    <th>Registered On</th>
                                    <th>Current Status</th>
                                    <th>Current Attendance</th>
                                    <th>Action</th>
                                    <th>Attendance</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{register.User && register.User.length > 0 && `${register.User[0].FirstName} ${register.User[0].LastName}`}</td>
                                    <td style={{ textTransform: "uppercase" }}>{register._id}</td>
                                    <td>{moment(register.createdAt).format("DD/MM/YYYY hh:mm:ss A")}</td>
                                    <td>{register.Approved === 1 ? "Approved" : "Rejected"}</td>
                                    <td>{register.Present === 1 ? "Present" : "Absent"}</td>
                                    <td>
                                        <button style={{ border: "none", padding: "5px 10px", borderRadius: "6px" }} className={`${(register.Approved === 1 ? "btn-danger" : "btn-success")}`} onClick={() => onApproveRegistration(register._id, (register.Approved === 0 ? 1 : 0))}>
                                            {register.Approved === 0 ? "Approve" : "Reject"}
                                        </button>
                                    </td>
                                    <td>
                                        <button style={{ border: "none", padding: "5px 10px", borderRadius: "6px" }} className={`${(register.Present === 1 ? "btn-danger" : "btn-success")}`} onClick={() => OnRegisterPresent(register._id, (register.Present === 0 ? 1 : 0))}>
                                            {register.Present === 0 ? "Present" : "Absent"}
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ShowEventRegisterList;